import { allMetadata } from 'constants/metadata';
import { complaints as complaintsBreadcrumbs } from 'constants/routes-breadcrumbs';
import { Routes } from 'constants/routes';
import { IComplaint } from 'constants/types';
import { getItemIdentifier } from 'utils/slug';
import { TopicThreadPage } from 'components/template/topic-thread';

interface Props {
  mainComplaint: IComplaint;
  childrenComplaints: IComplaint[];
}

export const ComplaintPage = ({ mainComplaint, childrenComplaints }: Props) => {
  return (
    <TopicThreadPage
      variant="complaint"
      mainItem={mainComplaint}
      childrenItems={childrenComplaints}
      metadata={allMetadata.complaint(mainComplaint)}
      isSearchInputMobileVisible
      breadcrumbs={[
        ...complaintsBreadcrumbs,
        {
          id: 2,
          path: Routes.complaint(getItemIdentifier(mainComplaint)),
          title: mainComplaint?.title ?? '',
        },
      ]}
    />
  );
};
